<template>
    <div
        v-if="currentSize <= 12 && order !== -1"
        class="app-grid__col"
        :class="classes"
        :style="colStyle"
    >
      <slot></slot>
    </div>
</template>

<script lang="ts" setup>
import { onBreakpointChanged, removeOnBreakpointChanged } from '@/utils/viewport';
import {
  computed, inject, onBeforeUnmount, onMounted, ref,
} from 'vue';

const props = defineProps<{
  s?: Record<string, number> | number | string
  order?: Record<string, number> | number,
  verticalStart?: boolean
  verticalCenter?: boolean
  verticalEnd?: boolean
}>();

const defaultColSize = inject<Record<string, number> | number | string>('defaultColSize', 12);

const currentSize = ref<number>(12);
const colStyle = computed(() => ({
  gridColumn: `auto/span ${currentSize.value}`,
  order: props.order,
}));

const classes = computed(() => {
  const classesArr = [];

  if (props.verticalCenter) {
    classesArr.push('align-self-center');
  } else if (props.verticalEnd) {
    classesArr.push('align-self-end');
  } else if (props.verticalStart) {
    classesArr.push('align-self-start');
  }

  return classesArr;
});

const getCurrentSize = (event: CustomEvent) => {
  let size = props.s || defaultColSize;
  const breakpoints = (event.detail?.breakpoints || ['xs']) as string[];

  if (typeof size === 'object') {
    let sizeByBp = 0;
    const propBps = size;

    breakpoints.forEach((bpKey) => {
      if (Object.keys(size).includes(bpKey)) {
        sizeByBp = parseInt(`${propBps[bpKey] || size || 0}`, 10);
      }
    });

    size = sizeByBp || 12;
  }

  currentSize.value = parseInt(`${size || 12}`, 10);
};

onMounted(() => {
  onBreakpointChanged(getCurrentSize, true);
});

onBeforeUnmount(() => {
  removeOnBreakpointChanged(getCurrentSize);
});
</script>
